// src/components/BurgerMenu.js
import React from "react";
import "../scss/BurgerMenu.scss";
import { MdClose } from "react-icons/md";

const BurgerMenu = ({ toggleMenu, isOpen }) => {
  return (
    <div
      className="burger-menu flex mx-5 gap-5 items-center my-auto text-lg"
      onClick={toggleMenu}
    >
      {
       isOpen ? (
           <span className="text-indigo-700 cursor-pointer"><MdClose size={30} /></span>
       ): (
        <>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </>
       )
      }
    </div>
  );
};

export default BurgerMenu;
